export default __webpack_public_path__ + "static/media/server-error.49aceb05.gif";